<script>
import { mapGetters } from 'vuex';
import { useBrowserPhoneStore } from 'dashboard/modules/browserPhone/store/browserPhone';
import SidebarProfileMenu from 'next/sidebar/SidebarProfileMenu.vue';
 
export default {
  name: 'FunctionBar',
  components: {
    SidebarProfileMenu,
  },
  computed: {
    ...mapGetters({
      canUseNativeBrowserPhone: 'getCurrentAccountHasBrowserPhoneAccess',
    }),
  },
  methods: {
    toggleBrowserPhoneVisibility() {
      const browserPhoneStore = useBrowserPhoneStore();

      if (browserPhoneStore.isWidgetOpen) {
        browserPhoneStore.close();
        return;
      }

      browserPhoneStore.open({ source: 'function_bar' });
    },
  },
};
</script>
 
<template>
  <div
    class="flex justify-between items-center bg-gradient-to-r from-[#2563eb] to-[#7e22ce] px-5 py-2.5 text-white h-[70px] flex-shrink-0 border-b border-[#475569] shadow-sm"
  >
    <div class="font-bold">
      <img
        src="../../assets/images/logo-iungo-branca2.png"
        alt="IUNGO PABX"
        class="w-[101px] h-[42px] flex-shrink-0 object-contain"
        href="https://iuconnect.iungo.cloud"
      />
    </div>

    <div class="flex items-center w-[450px]">
      <button
        v-if="canUseNativeBrowserPhone"
        id="browser-phone-toggle-button"
        type="button"
        class="w-[39px] h-[39px] flex-shrink-0 bg-white mr-4 flex items-center justify-center"
        :aria-label="$t('FUNCTION_BAR.TOGGLE_PHONE')"
        @click="toggleBrowserPhoneVisibility"
      >
        <img
          src="../../assets/images/phone-icon.svg"
          :alt="$t('FUNCTION_BAR.TOGGLE_PHONE')"
          class="w-full h-auto"
        />
      </button>
      <SidebarProfileMenu
        class="flex items-center justify-end avatar-function-bar"
        :is-collapsed="true"
        variant="functionbar"
      />
    </div>
  </div>
</template>

<style scoped>
.avatar-function-bar {
  width: 39px;
  height: 39px;
  flex-shrink: 0;
}
.avatar-function-bar button span div .avatar-container {
  width: 39px;
  height: 39px;
  background: red;
}

.avatar-function-bar button span div img {
  width: 39px;
  height: 39px;
  background: yellow;
}
</style>